import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { Card } from "../../common/card/card";
import { useLocalizedName } from "../../../globals/langHelpers";
import { Caption, Value, CardTitle } from "../../admin/workOrderDetails";
import { useWorkOrderStyles } from "./workOrderStyles";
import "./workorderdetails.css";

export default function Comments(props) {
    const { comments, workorderInfo } = props;
    const { getLocalizedName } = useLocalizedName();
    const classes = useWorkOrderStyles();
    const intl = useIntl();

    return (
        <>
            <Card>
                <Grid container className={classes.row}>
                    <Grid item sm={12}>
                        <CardTitle>
                            <FormattedMessage
                                id="tech.wo-details.bell-creation-comments-caption"
                                defaultMessage="Bell creation comments"
                                description="Technicians work order details bell creation comments caption"
                            />
                        </CardTitle>
                        <p>{workorderInfo?.additionalComments}</p>
                        <CardTitle>
                            <FormattedMessage
                                id="admin.work-order-details.cost-info.comments-title"
                                defaultMessage="Comments"
                                description="Admin work order comments title"
                            />
                        </CardTitle>
                        {comments?.length > 0
                            ? comments
                                  .filter((comment) => comment?.commentType?.id !== 4)
                                  .map((comment) => (
                                      <Grid item sm={12} style={{ paddingTop: "5px", paddingBottom: "15px" }}>
                                          <Caption>
                                              {getLocalizedName({ object: comment.commentType })}
                                              <span>
                                                  {intl.locale == "en" ? "saved on" : "enregistré le"}{" "}
                                                  {moment
                                                      .utc(new Date(comment.updatedDate ? comment.updatedDate : comment.createdDate))
                                                      .format("MMM D, YYYY, h:mm a")}
                                              </span>
                                          </Caption>
                                          {props?.comment?.commentType?.id !== 2 && (
                                              <div className={classes.divtext}>
                                                  <Value>{comment?.comment}</Value>
                                              </div>
                                          )}
                                      </Grid>
                                  ))
                            : null}
                    </Grid>
                </Grid>
            </Card>
        </>
    );
}
